import { action, makeObservable, observable } from "mobx";

export class TutorialFrameStore {
	@observable isShow = false;

	constructor() {
		makeObservable(this);
	}

	@action.bound
	setIsShow(value: boolean) {
		this.isShow = value;
	}

	@action.bound
	close() {
		this.setIsShow(false);
	}

	@action.bound
	open() {
		this.setIsShow(true);
	}
}
